module.exports = __webpack_public_path__ + "img/logo_platinriver@2x.d957604.png";